<div class="wrap uk-margin-top">
    <div *ngIf="loading === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loading === false">
        <div class="uk-form-stacked uk-margin-large uk-grid-medium" uk-grid>
            <div class="uk-width-12-12 uk-margin-small-top" style="padding-left: 20px;">
                <div class="back-button" [routerLink]="['/ressource/station/list']">
                    <img src="../../../assets/icons/Back.svg" width="32px" height="32px" alt="back">
                    <span>Liste des stations</span>
                </div>
            </div>
            <div class="uk-width-12-12 uk-position-relative uk-margin-top">
                <div class="main-title bold uk-width-1-2">{{ station.name }}</div>
                <div class="uk-align-right@s">
                    <button class="back-button regular" type="submit" (click)="updateStation()" style="padding-right: 20px;">
                        <span class="uk-text-uppercase uk-visible@s">Valider les changements</span>
                        <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                    </button>
                    <button class="back-button regular" style="padding-right: 20px;"
                    type="button" uk-toggle="target: #choice-validation-delete-station">
                        <span class="uk-text-uppercase uk-visible@s">Supprimer la station</span>
                        <img src="../../../assets/icons/Close.svg" width="32px" height="32px" alt="back">
                    </button>
                </div>
            </div>
            <div uk-grid class="uk-width-12-12 padding-20 uk-margin-top vop-background-white remove-grid-ml-pl" style="padding-bottom: inherit;">
                <div class="uk-width-8-12@s" style="min-height: 466.66px;">
                    <div class="img-wrap">
                        <div uk-lightbox>
                            <div *ngIf="loadingPhoto === true" class="uk-position-center" uk-spinner></div>
                            <div *ngIf="loadingPhoto === false" uk-lightbox>
                                <a class="uk-button uk-button-default" [href]="station.photo">
                                    <img [src]="station.photo"
                                        onerror="this.src='../../../../assets/icons/Building.svg';this.className='img-error';">
                                </a>
                            </div>
                            <button class="uk-position-absolute button large edit-button" (click)="modifyPhoto()">
                                <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                            </button>
                        </div>
                    </div>
                </div>
                <div class="uk-width-4-12@s uk-grid-small@s" uk-grid>
                    <div class="uk-width-3-3">
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Nom de la station</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text" [(ngModel)]="station.name">
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Adresse</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text" [(ngModel)]="station.address">
                                <input class="input alt color-cold-grey bold uk-width-1-4" type="text" [(ngModel)]="station.zipCode">
                                <input class="input alt color-cold-grey bold uk-width-3-4" type="text" [(ngModel)]="station.city">
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Longitude</label>
                            <div class="uk-form-controls">
                                <!-- <span class="color-cold-grey bold uk-width-1-1">{{ station.longitude }}</span> -->
                                <input class="input alt color-cold-grey bold uk-width-3-4" type="text" [(ngModel)]="station.longitude">
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Latitude</label>
                            <div class="uk-form-controls">
                                <!-- <span class="color-cold-grey bold uk-width-1-1">{{ station.latitude }}</span> -->
                                <input class="input alt color-cold-grey bold uk-width-3-4" type="text" [(ngModel)]="station.latitude">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px; padding-bottom: 0px;"></div>
            <div class="uk-width-12-12 padding-20">
                <div class="title bold uk-margin-medium-bottom">
                    <span>Véhicules liés à cette station</span>
                </div>
                <div class="uk-width-12-12" style="width: calc(100% + 20px); max-width: calc(100% + 20px);">

                    <div *ngIf="vehicles.length === 0" class="bold uk-width-1-1">
                        <div>Aucun vehicule lier à cette station</div>
                    </div>

                    <div uk-grid *ngFor="let vehicle of vehicles; let i = index" class="uk-width-1-1 item-list light color-grey remove-grid-ml-pl" style="height: 124px;">
                        <div class="uk-width-2-12 item-column img-wrap" style="background: #eaeaea;">
                            <div uk-lightbox>
                                <a class="uk-button uk-button-default" [href]="vehicle.vehiclePicture">
                                    <img class="uk-position-absolute"
                                    [src]="vehicle.vehiclePicture" alt="adherent"
                                    onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';"/>
                                </a>
                            </div>
                        </div>
                        <div class="uk-width-10-12 item-column remove-grid-ml-pl" uk-grid
                        style="padding-left: 20px !important; padding-right: 20px !important;">
                            <div class="uk-width-2-12 item-column bold border" style="font-size: 15px;">
                                <span class="title">{{ vehicle.name }}</span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border uk-text-uppercase" style="font-size: 15px;">
                                <span>{{ vehicle.brand }}</span>
                            </div>
                            <div class="uk-width-3-12 item-column regular border uk-text-uppercase" style="font-size: 15px;">
                                <span>{{ vehicle.model }}</span>
                            </div>
                            <div class="uk-width-3-12 item-column regular border uk-text-uppercase" style="font-size: 15px;">
                                <div>
                                    <span class="material-icons vertical-align-middle" [class.color-green]="vehicle.idDisabledVehicle === 0"
                                    [class.color-orange]="vehicle.idDisabledVehicle > 1">fiber_manual_record</span>
                                    <span *ngIf="vehicle.idDisabledVehicle === 0" class="title bold vertical-align-middle uk-margin-small-left">Activé</span>
                                    <span *ngIf="vehicle.idDisabledVehicle > 0" class="title bold vertical-align-middle uk-margin-small-left">Désactivé</span>
                                </div>
                            </div>
                            <div class="uk-width-2-12 item-column border">
                                <button class="back-button uk-text-right" [routerLink]="['/ressource/vehicle/informations', vehicle.id]">
                                    <img src="../../../assets/icons/ArrowRight.svg" width="32px" height="32px" alt="edit"/>
                                </button>
                                <button class="back-button uk-text-right">
                                    <img (click)="deleteVehicle(vehicle)" class="pointer"
                                    style="filter: brightness(200%);" src="../../../assets/icons/delete.svg"
                                    width="32px" height="32px" alt="delete"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <button class="button bold uk-float-right add-user uk-margin-medium-top"
                            uk-toggle="target: #find-vehicle" type="button">
                        <span>Ajouter un véhicule</span>
                        <img src="../../../assets/icons/Add.svg" width="32" height="32" alt="add" class="uk-margin-left">
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="loading === false" class="uk-margin" uk-grid>
    <div class="uk-width-1-1 uk-position-relative">
        <button class="uk-position-absolute button large edit-button" style="z-index: 1000;padding: 0;"
        href="#position-station" uk-toggle (click)="appPositionStation.fixCenter()">
            <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
        </button>
        <div style="width:100%; height: 939px;" id="map"></div>
    </div>
</div>

<app-position-station
    [latitude]="station.latitude"
    [longitude]="station.longitude"
    [station]="station"
    (changed)="changePosition()"
    #appPositionStation
></app-position-station>

<app-find-vehicle
    [actualVehicles]="vehicles"
    (changed)="addVehicle($event)"
></app-find-vehicle>

<app-choice-validation
    [name]="'delete-station'"
    (changed)="($event === true) ? deleteStation() : false;"
></app-choice-validation>